import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle
        cx={8}
        cy={8}
        r={8}
        transform="rotate(90 8 8)"
        fill="#000"
        fillOpacity={0.3}
      />
      <Path
        d="M4 6.664a.572.572 0 00.211.445L7.64 9.87a.571.571 0 00.725 0l3.429-2.858a.572.572 0 00-.732-.88L8 8.687l-3.063-2.47A.571.571 0 004 6.665z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
